<template>
  <div>
    <v-img
      src="../assets/img/console.jpg"
      max-height="300"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <v-row justify="center" align-content="center" style="height: 100%;">
        <v-col cols="12">
          <h1 class="white--text text-center">Orión Stereo</h1>
        </v-col>
        <v-btn
          color="secondary"
          class="primary--text"
          @click="playPause()"
        >{{playingText}}</v-btn>
      </v-row>
    </v-img>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card flat tile class="transparent">
            <v-card-title class="headline">Promesa del día</v-card-title>
            <v-card-text>
              <blockquote class="blockquote">{{quote}}</blockquote>
              <v-row justify="center">
                <v-btn
                  v-if="!isQuoteShort"
                  color="secondary"
                  class="primary--text"
                  @click="modalPensamiento = true"
                >Leer mas</v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card flat tile class="transparent">
            <v-card-title class="headline">Matutinas</v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="4" v-for="item in matutinas" :key="item.id">
                  <v-card>
                    <v-card-title class="primary white--text">
                      {{item.libro.tipo}}
                    </v-card-title>
                    <v-card-text>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="text-uppercase">
                            {{item.titulo}}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{item.libro.anho}}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-avatar tile style="height: 100px; width: 60px;">
                          <v-img :src="item.libro.imagen"></v-img>
                        </v-list-item-avatar>
                      </v-list-item>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        block
                        color="secondary"
                        class="my-2 primary--text"
                        @click="goMatutina(item)"
                      >Leer</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="!matutinas.length">
                  <v-alert type="info">
                    No hay matutinas registradas para hoy
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card-title class="headline">Noticias</v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="6" md="4" v-for="item in posts" :key="item.id">
                <v-card>
                  <v-card-title class="primary white--text">
                    {{item.title}}
                  </v-card-title>
                  <v-img
                    v-if="item.feature_image"
                    :src="item.feature_image"
                    height="180"
                  ></v-img>
                  <v-card-text>{{item.excerpt}}</v-card-text>
                  <v-card-actions>
                    <v-btn
                      block
                      color="secondary"
                      class="primary--text"
                      :to="{ name: 'blog', params: { url: item.url } }"
                    >Leer mas</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="!posts.length">
                <v-alert type="info">
                  No hay noticias registradas
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>
      <v-dialog v-model="modalPensamiento" max-width="600">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon class="secondary--text mr-2">fas fa-quote-left</v-icon>
            Promesa del día
          </v-card-title>
          <v-card-text>
            <blockquote class="blockquote mt-1">
              {{quoteLarge}}
            </blockquote>
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              color="secondary"
              class="primary--text"
              @click="modalPensamiento = false"
            >Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { KEY, CONTENT_API } from '../config'
import { mapGetters, mapMutations } from 'vuex'
import dayjs from 'dayjs'
const PUBLIC_VAPID_KEY = 'BGovO78TL7-ge6J9lzxTgl2Tu3sQU6yDvMpEuK4u66NEM8KGoppgB-swWuQYwmjajbab_b30xyPkbtCTtWjul9o'
export default {
  data () {
    return {
      quote: '',
      quoteLarge: '',
      posts: [],
      matutinas: [],
      modalPensamiento: false,
      isSuscribed: false,
      isQuoteShort: false
    }
  },
  computed: {
    ...mapGetters(['getPlaying']),
    playingText () {
      return this.getPlaying ? 'Detener' : 'Reproducir'
    }
  },
  methods: {
    ...mapMutations(['setPlaying', 'setMatutina']),
    getPensamiento () {
      this.$http.pensamientos
        .get('?_sort=fecha:DESC&_limit=1')
        .then(res => res.data)
        .then(res => {
          if (res[0].pensamiento.length < 200) {
            this.isQuoteShort = true
            this.quote = res[0].pensamiento
          } else {
            this.isQuoteShort = false
            this.quote = `${res[0].pensamiento.substring(0, 160)}...`
            this.quoteLarge = res[0].pensamiento
          }
        })
    },
    getPosts () {
      this.$http.posts
        .get(`?key=${KEY}&filter=tag:noticias&limit=6`)
        .then(res => res.data.posts)
        .then(res => {
          this.posts = res.map(i => {
            return {
              ...i,
              excerpt: `${i.excerpt.substring(0, 140)}...`
            }
          })
        })
    },
    getMatutinas () {
      const today = dayjs().format('YYYY-MM-DD')
      this.$http.matutinas
        .get(`?fecha_eq=${today}`)
        .then(res => res.data)
        .then(res => {
          res.forEach(i => {
            i.libro.imagen = `${CONTENT_API}${i.libro.imagen.url}`
            i.fecha = dayjs(i.fecha).add(1, 'd').format('DD-MM-YYYY')
          })
          this.matutinas = res
        })
    },
    goMatutina (item) {
      this.setMatutina(item)
      this.$router.push({ name: 'matutina' })
    },
    playPause () {
      if (this.getPlaying) {
        this.setPlaying(false)
      } else {
        this.setPlaying(true)
      }
    },
    urlBase64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
      const rawData = window.atob(base64)
      const outputArray = new Uint8Array(rawData.length)
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    },
    async registerPush () {
      if ('Notification' in window) {
        try {
          const registration = await navigator.serviceWorker.register('/sw.js', {
            scope: '/'
          })
          const resSubscription = await registration.pushManager.getSubscription()
          this.isSubscribed = !(resSubscription === null)
          if (!this.isSubscribed) {
            const subscription = await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: this.urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
            })

            await this.$http.notificaciones.post('/subscription', subscription)
            // await fetch('https://push.orionstereo.org/subscription', {
            //   method: 'POST',
            //   body: JSON.stringify(subscription),
            //   headers: {
            //     'Content-Type': 'application/json'
            //   }
            // })
            this.isSubscribed = true
            /* eslint-disable no-console */
            console.log('Subscribed to push')
          }
        } catch (error) {
          /* eslint-disable no-console */
          console.log(error)
        }
      }
    }
  },
  mounted () {
    this.getPosts()
    this.getPensamiento()
    this.getMatutinas()
    this.registerPush()
  }
}
</script>
